export function toggleClass(elementId, className) {
  document.getElementById(elementId)?.classList.toggle(className);
}
